export const SCREEN_SIZES = ['xs', 'sm', 'md', 'lg'];
export const REORDER_VARIANTS = ['last', 'first'];
